/**
 * Export transactions to CSV
 */
export const exportToCSV = (transactions, filename = 'routeflow-transactions.csv') => {
  if (!transactions || transactions.length === 0) {
    alert('No transactions to export');
    return;
  }

  // Define CSV headers
  const headers = [
    'Transaction ID',
    'Date',
    'Amount',
    'From Currency',
    'To Currency',
    'From Country',
    'To Country',
    'Recipient',
    'Status',
    'Service Fee',
    'Total Amount',
    'Route',
    'Transaction Hash',
    'Fee Transaction Hash'
  ];

  // Convert transactions to CSV rows
  const rows = transactions.map(txn => [
    txn.id || '',
    txn.created_at ? new Date(txn.created_at).toLocaleString() : '',
    txn.amount || '',
    txn.from_currency || '',
    txn.to_currency || '',
    txn.from_country || '',
    txn.to_country || '',
    txn.recipient_name || '',
    txn.status || '',
    txn.service_fee || '',
    txn.total_amount || '',
    txn.route || '',
    txn.tx_hash || '',
    txn.fee_tx_hash || ''
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

/**
 * Export transactions to JSON
 */
export const exportToJSON = (transactions, filename = 'routeflow-transactions.json') => {
  if (!transactions || transactions.length === 0) {
    alert('No transactions to export');
    return;
  }

  const jsonContent = JSON.stringify(transactions, null, 2);
  const blob = new Blob([jsonContent], { type: 'application/json' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

/**
 * Generate transaction receipt (text format)
 */
export const generateReceipt = (transaction) => {
  const date = transaction.created_at ? new Date(transaction.created_at).toLocaleString() : 'N/A';
  
  const receipt = `
╔════════════════════════════════════════════════╗
║           ROUTEFLOW AI                         ║
║        TRANSACTION RECEIPT                     ║
╚════════════════════════════════════════════════╝

Transaction ID: ${transaction.id}
Date: ${date}

FROM:
  Country: ${transaction.from_country}
  Currency: ${transaction.from_currency}
  Amount: ${transaction.amount}

TO:
  Country: ${transaction.to_country}
  Currency: ${transaction.to_currency}
  Recipient: ${transaction.recipient_name}
  Account: ${transaction.recipient_account}

FEES:
  Service Fee: $${transaction.service_fee || '0.00'}
  Network Fee: $${transaction.fees || '0.00'}
  Total Amount: $${transaction.total_amount || '0.00'}

BLOCKCHAIN:
  Route: ${transaction.route || 'N/A'}
  Status: ${transaction.status || 'N/A'}
  ${transaction.tx_hash ? `Transaction Hash: ${transaction.tx_hash}` : ''}
  ${transaction.fee_tx_hash ? `Fee Hash: ${transaction.fee_tx_hash}` : ''}

STATUS: ${transaction.status?.toUpperCase() || 'PENDING'}

Thank you for using RouteFlow AI!
For support: support@routeflowai.com
  `;

  return receipt;
};

/**
 * Download receipt as text file
 */
export const downloadReceipt = (transaction) => {
  const receipt = generateReceipt(transaction);
  const blob = new Blob([receipt], { type: 'text/plain' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `receipt-${transaction.id}.txt`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
